import { AbstractControl } from "@angular/forms";

/**
 * A dirty control sends its value, including `""` when the instructor cleared the note.
 * A pristine empty control is omitted so it is not a delete.
 * A pristine non-empty value is the admin template or a loaded note, and must be saved.
 */
export function signOffNoteDraftValue(control: AbstractControl | null | undefined): string | undefined {
	if (!control) return undefined;
	const value = String(control.value ?? "");
	if (control.dirty || value.trim()) return value;
	return undefined;
}

/** Dirty edits win, including a clear. A prefilled note is kept. An empty untouched control keeps a saved string. */
export function signOffNoteForAutosave(control: AbstractControl | null | undefined, saved: unknown): string | undefined {
	const edited = signOffNoteDraftValue(control);
	if (edited !== undefined) return edited;
	return typeof saved === "string" ? saved : undefined;
}
